import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { fetchInitData } from '../app/appSlice';

export const changeItemOwner = createAsyncThunk(
  'itemOwners/change',
  async (data, thunkAPI) => {
    // If owner changes, must get new globals
    await thunkAPI.dispatch(fetchInitData(data));

    return data;
  }
);

const initialState = {
  itemOwners: [
    'PC1',
    'PC24'
  ],
  selected: 'PC1',
  status: 'idle',
  error: null
};

// There might be a better way than this..?
const ownerIdFromUrl = initialState.itemOwners.find(ownerId => window.location.hash.includes(`owner/${ownerId}/`));
if(ownerIdFromUrl) {
  initialState.selected = ownerIdFromUrl;
}

export const itemOwnersSlice = createSlice({
  name: 'itemOwners',
  initialState,
  reducers: {
    clearRequestState: (state, action) => {
      state.error = null;
      state.status = 'idle';
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [changeItemOwner.fulfilled]: (state, action) => {
      state.selected = action.payload;
    },
  }
});

export const { clearRequestState } = itemOwnersSlice.actions;

export const selectItemOwners = state => state.itemOwners.itemOwners;
export const selectCurrentItemOwner = state => state.itemOwners.selected;

export default itemOwnersSlice.reducer;
